//Formik
import { useField } from "formik"
import FormikTextInput from "../../../../../helpers/formikInputs/FormikTextInput"
import FormikNumberInput from "../../../../../helpers/formikInputs/FormikNumberInput"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"
import assessStyles from "../../../../../styles/assessments/Assessment.module.css"

//PrimeReact
import { Button } from "primereact/button"
import { CSS } from "@dnd-kit/utilities"
import { useSortable } from "@dnd-kit/sortable"

export default function QuestionLabelEntry({
  options,
  option,
  formikParentName,
  onDelete,
  disabled,
}) {
  const index = options.findIndex(
    (optionsEntry) => optionsEntry.id === option.id
  )

  const thisOptionFormikName = `${formikParentName}[${index}]`

  const [, , deleteHelper] = useField(`${thisOptionFormikName}.isDeleted`)

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: option.id,
    data: { option: option },
  })

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  }

  return (
    <div
      className={`${myStyles.questionOptionLayout} ${myStyles.questionLabelLayout}`}
      ref={setNodeRef}
      style={style}
    >
      <div
        className={myStyles.questionOptionLayoutIcon}
        {...attributes}
        {...listeners}
      >
        <span className={`material-icons`}>{"drag_indicator"}</span>
      </div>
      <div className={myStyles.questionOptionLayoutLabel}>
        <FormikTextInput
          name={`${thisOptionFormikName}.text`}
          disabled={disabled}
        />
      </div>
      <div className={myStyles.questionOptionLayoutAction}>
        <Button
          type="button"
          className={assessStyles.actionButton}
          onClick={() => {
            deleteHelper.setValue(true)

            if (onDelete) {
              onDelete()
            }
          }}
          tooltip="Delete label"
          tooltipOptions={{ position: "bottom" }}
          disabled={disabled}
        >
          <span className={`material-icons`}>{"delete"}</span>
        </Button>
      </div>
    </div>
  )
}
